import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as _ from "lodash";
import { LoadingBarService } from "@ngx-loading-bar/core";
import { SapRequestService } from "src/app/shared/services/sap-request";
import { HeaderService, ServiceOrderService } from "../../../shared";

@Component({
  selector: "app-service-order-list",
  templateUrl: "./service-order-list.component.html",
  styleUrls: ["./service-order-list.component.scss"],
})
export class ServiceOrderListComponent implements OnInit {
  typeComponent = "service-order";

  textBtnNew = "Nova Ordem de Serviço";
  urlBtnNew = "/panel/service-order/new";

  currentUrl = "/panel/service-order";

  dataList;

  modal = false;
  alert: Boolean = false;
  sapRequestData;

  pag;
  filters;
  cacheObj;

  serviceOrderRequest;

  totalServiceOrders;

  constructor(
    private headerService: HeaderService,
    private serviceOrderService: ServiceOrderService,
    private loadingBarService: LoadingBarService,
    private activatedRoute: ActivatedRoute,
    private sapRequestService: SapRequestService
  ) {
    if (this.activatedRoute.snapshot.params.pag) {
      this.pag = this.activatedRoute.snapshot.params.pag;
    } else {
      this.pag = 1;
    }
  }

  ngOnInit() {
    this.headerService.changeTitle("Ordens de serviço");

    this.headerService.changeSubtitle("");

    this.headerService.changeDatePicker(false);

    this.dataList = {};

    this.translateFilter();
  }

  serviceOderList(filters = "") {
    this.loadingBarService.stop();

    this.loadingBarService.start();

    if (this.serviceOrderRequest) {
      this.serviceOrderRequest.unsubscribe();
    }

    this.serviceOrderRequest = this.serviceOrderService
      .listServiceOrders(filters)
      .subscribe((response) => {
        this.loadingBarService.complete();

        this.dataList = response;
        this.alert = false;

        this.dataList.tbody.map((item) => {
          if (item.data[7] === "Aguardando Pedido SAP") {
            this.alert = true;
          }
        });

        this.totalServiceOrders = response["total"];
      });
  }

  setPag(setPag) {
    this.pag = setPag;
    this.translateFilter();
  }

  openModal(data) {
    this.sapRequestService.getRequest(data).subscribe((response) => {
      this.sapRequestData = response;
      this.modal = true;
    });
  }

  closeModal() {
    this.modal = false;
  }

  translateFilter(obj?) {
    this.filters = [];

    if (obj) {
      this.cacheObj = obj;
    }

    _.forOwn(this.cacheObj, (value, key) => {
      this.filters.push(`${key}=${value}`);
    });

    this.serviceOderList(`?pageNumber=${this.pag}&` + this.filters.join("&"));
  }
}
